import localhost from '../../utils/localhost.js';
import axios from 'axios';
import random from '../../utils/random';

const goods = {
  state: {
    goodsList: null,
    groupList: null, // 分组信息
    stepsList: null // 步骤信息
  },
  mutations: {
    goodsListUpdate (state, data) {
      state.goodsList = data;
    },
    groupListUpdate (state, data) {
      state.groupList = data;
    },
    stepsListupdate (state, data) {
      state.stepsList = data;
    },
  },
  actions: {
    getGoodsList ({commit}, data) {
      var self = this;
      var params = new URLSearchParams();
      params.append('appId', data.appId);
      params.append('pageIndex', data.pageIndex);
      params.append('pageSize', data.pageSize);
      // 以下为筛选条件
      if (data.groupId) {
        params.append('goodsGroupId', data.groupId);
      }
      if (data.shelves) {
        params.append('shelves', data.shelves); // EFFECTIVE 上架， INEFFECTIVE 下架
      }
      if (data.commission) {
        params.append('commission', data.commission); // 0 参与推广  1 不参与
      }
      if (data.recommend) {
        params.append('recommend', data.recommend); // 0 首页推荐
      }

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/getGoodsList', params)
          .then((res) => {
            if (!res.data.success) {
              reject('获取商品列表失败');
            } else {
              commit('goodsListUpdate', res.data.data.list);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    getGroupList ({commit}, data) {
      var params = new URLSearchParams();
      params.append('appId', data.appId);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/getGoodsGroupList', params)
          .then((res) => {
            if (!res.data.success) {
              reject('获取商品品类失败');
            } else {
              commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    getStepList ({commit}) {
      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/getGoodsStepList')
          .then((res) => {
            if (!res.data.success) {
              reject('获取使用步骤失败');
            } else {
              res.data.data.map(step => {
                if (step && step.stepInfo) {
                  step.stepInfo = JSON.parse(step.stepInfo);
                }
                return step;
              });
              commit('stepsListupdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    addGoodsStep ({commit}, data) { // 新增步骤
      var params = new URLSearchParams();
      params.append('stepName', data.stepName);
      params.append('stepInfo', JSON.stringify(data.stepInfo));

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/addGoodsStep', params)
          .then((res) => {
            if (!res.data.success) {
              reject('批量上下架失败');
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    updateGoodsStep ({commit}, data) { // 修改步骤
      var params = new URLSearchParams();
      params.append('id', data.id);
      params.append('stepName', data.stepName);
      params.append('stepInfo', JSON.stringify(data.stepInfo));

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/updateGoodsStep', params)
          .then((res) => {
            if (!res.data.success) {
              reject('批量上下架失败');
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    editUnderShelf ({commit}, data) { // 批量上下架
      var params = new URLSearchParams();
      params.append('goodsList', data.goodsList);
      params.append('type', data.type); // type 1 上架 2 下架

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/editUnderShelf', params)
          .then((res) => {
            if (!res.data.success) {
              reject('批量上下架失败');
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    editRecommend ({commit}, data) { // 批量首页推荐设置
      var params = new URLSearchParams();
      params.append('appId', data.appId);
      params.append('goodsList', data.goodsList);
      params.append('type', data.type); // type 1 首页推荐 2 取消首页推荐

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/editRecommend', params)
          .then((res) => {
            if (!res.data.success) {
              reject('批量设置首页推荐失败');
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    editGoodsGroupBatch ({commit}, data) { // 批量改分组
      var params = new URLSearchParams();
      params.append('groupId', data.groupId);
      params.append('goodsList', data.goodsList);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/editGoodsGroupBatch', params)
          .then((res) => {
            if (!res.data.success) {
              reject('批量改分组失败');
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    getGoodsByGroupId ({commit}, data) {
      var params = new URLSearchParams();
      params.append('appId', data.appId);
      params.append('goodsGroupId', data.groupId);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/getGoodsByGroupId', params)
          .then((res) => {
            if (!res.data.success) {
              reject('获取品类对应商品失败');
            } else {
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    editGoodsGroup ({commit}, data) { // 编辑或者新建分组信息
      var params = new URLSearchParams();
      params.append('appId', data.appId);
      params.append('type', data.type); // 1 增 2 删 3 改   (删暂不可用)
      params.append('goodsGroupName', data.groupName);
      params.append('icon', data.icon);
      if (data.type == 3) {
        params.append('goodsGroupId', data.groupId);
      }

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/editGoodsGroup', params)
          .then((res) => {
            if (!res.data.success) {
              reject('编辑分组信息失败');
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    manageGoods ({commit}, data) { // 编辑或者新建商品信息
      var params = new URLSearchParams();
      params.append('appId', data.appId);
      params.append('type', data.type); // 1 增 2 改
      if (data.type == 2) { // 仅编辑时有商品id
        params.append('goodsId', data.goodsId);
        if (data.standardsId && data.standardsId != -1) {
          params.append('standardsId', data.standardsId);
        }
        if (data.noPartakePrice) {
          params.append('noPartakePrice', data.noPartakePrice);
        }
      }
      params.append('goodsType', data.goodsType); // 商品类型
      params.append('shelves', data.shelves); // 默认上架
      params.append('amount', data.amount > 0 ? data.amount : 0); // 限购数量
      params.append('remark', data.remark); // 备注
      params.append('lockPowderTime', data.lockPowderTime); // 锁粉时间（天）
      params.append('displayStatus', data.displayStatus); // 是否显示在前台 0 显示 1 不显示
      params.append('goldenBeans', data.goldenBeans); // 金豆
      params.append('noPartakePrice', data.noPartakePrice); // 不参与分佣金额，负数表示补贴金额
      if (data.commissionSystem != -1 && data.commissionSystem) {
        params.append('commissionSystem', data.commissionSystem); // 佣金体系
      }
      if (data.goodsGroupId != -1 && data.goodsGroupId) {
        params.append('goodsGroupId', data.goodsGroupId); // 商品品类
      }
      if (data.goodsStepList && data.goodsStepList.length > 0) {
        params.append('goodsStepList', JSON.stringify(data.goodsStepList)); // 商品步骤
      }
      params.append('goodsStandard', JSON.stringify(data.goodsStandard)); // 商品规格, 数组序列化

      data.goodsInfo.pinTuanCourseList = data.goodsInfo.pinTuanCourseList.filter(lists => {
        return lists && lists.courseId && lists.courseName;
      });

      params.append('goodsInfo', JSON.stringify(data.goodsInfo)); // 商品详情, 数组序列化

      // 众筹相关参数
      if (data.goodsType === 'CROWDFUNDING') {
        params.append('startTime', String(data.startTime)); // 众筹开始时间
        params.append('endTime', String(data.endTime)); // 众筹结束时间
        params.append('crowdFundingPrice', data.crowdFundingPrice); // 众筹金额
      }

      // 拼团相关参数
      if (data.goodsType !== 'CROWDFUNDING' && data.goodsType !== 'FREE') {
        params.append('startTime', String(data.startTime)); // 拼团开始时间
        params.append('endTime', String(data.endTime)); // 拼团结束时间
        params.append('pinTuanPrice', data.pinTuanPrice); // 拼团金额
        params.append('numberOfPeople', data.numberOfPeople); // 拼团人数
      }

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/shop/manageGoods', params)
          .then((res) => {
            if (!res.data.success) {
              reject(res.data.errorMsg);
            } else {
              // commit('groupListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject('请求发生错误：' + err);
        })
      });
    },
  },
  getters: {}
};

export default goods;



// WEBPACK FOOTER //
// ./src/vuex/modules/goods.js